import { Form, InputGroup } from 'react-bootstrap';

const FormikInputWithIcon = ({ field, form, placeholder, imageSource, onFocus, ...props }) => {
  return (
    <InputGroup className="icon-input mb-3">
      <InputGroup.Text className="icon-input-prepend">
        <img src={imageSource} alt="" />
      </InputGroup.Text>

      <Form.Control
        {...field}
        {...props}
        maxLength={50}
        placeholder={placeholder}
        className="icon-input-field"
        onFocus={(e) => {
          field.onFocus && field.onFocus(e);
          onFocus && onFocus(e);
        }}
      />
    </InputGroup>
  );
};

export default FormikInputWithIcon;
